<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <PromotionForm
          v-model="promotion"
          title="Nová propagace"
          :edit="false"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PromotionForm from '@/components/forms/PromotionForm'

export default {
  name: 'PromotionAdd',
  components: {
    PromotionForm,
  },
  data() {
    return {
      promotion: {
        showIn: 5,
        enabled: false,
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    ...mapActions({
      createPromotion: 'promotion/createPromotion',
    }),
    save(data) {
      this.saving = true
      this.createPromotion({ promotion: this.promotion, files: data.files })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'promotions.detail',
              params: { promotionId: response.data.id },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
